/*RQ added this "Variants pull-down doesn't work in Safari " STARTS*/
$(document).ready(function () {
  // if (
  //   navigator.userAgent.indexOf('Safari') != -1 &&
  //   navigator.userAgent.indexOf('Chrome') == -1 &&
  //   navigator.userAgent.indexOf('CriOS/') == -1
  // ) {
  // $('.wetheme-dropdown__wrapper').click(function(eb) {
  //    $(".selector-wrapper ul").toggleClass('rq-get-open');
  //     eb.preventDefault();
  // });
  // /*$('.selector-wrapper button').click(function(eb) {
  //  eb.preventDefault();
  //    $(this).closest(".selector-wrapper").find("wetheme-dropdown--down").addClass('wetheme-dropdown--open');
  //    $(this).attr("aria-expanded","true");
  //    $(this).closest(".selector-wrapper").find('ul').addClass('rq-get-open');
  // });
  // $('.selector-wrapper ul li').click(function() {
  //   $(this).closest(".selector-wrapper").find('ul').removeClass('rq-get-open');
  //   $(".selector-wrapper ul").hide();
  // });*/
  // }
  // /*$('body').click(function(eb) {
  //     eb.preventDefault();
  //   $('.selector-wrapper ul').addClass('rq-get-open');
  // });*/
});
/*RQ added this "Variants pull-down doesn't work in Safari " ENDS*/

//gallery

$(document).ready(function () {
  $(".rq-product-slider-new").slick({
    //autoplay:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    draggable: true,
    adaptiveHeight: true,
    //fade:true,
    //asNavFor: '.rq-thumbnail-slider',
    //prevArrow: false,
    //nextArrow: false,

    infinite: false,

    prevArrow:
      '<button class="rq-PrevArrow" aria-label="Previous slide"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  x="0px" y="0px"	 width="123" height="122" viewBox="0 0 123 122" xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="40.4" y="41.4" class="st0" width="43.2" height="40.3"/><path d="M95.8,61.2c0-19.2-15.7-34.8-35.1-34.8c-19.4,0-35.1,15.6-35.1,34.8c0,19.2,15.7,34.8,35.1,34.8	C80.1,95.9,95.8,80.4,95.8,61.2z M53.7,61.2l11.6-11.4l1.7,1.7l-9.8,9.7L67,71.3L65.2,73L53.7,61.2z"/></svg></button>',
    nextArrow:
      '<button class="rq-NextArrow" aria-label="Next slide"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="123" height="122" viewBox="0 0 123 122"  xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="39.4" y="40.8" class="st0" width="43.2" height="40.3"/><path d="M27.2,60.8c0,19.2,15.7,34.8,35.1,34.8c19.4,0,35.1-15.6,35.1-34.8c0-19.2-15.7-34.8-35.1-34.8 C42.9,26.1,27.2,41.6,27.2,60.8z M69.3,60.8L57.8,72.3L56,70.5l9.8-9.7L56,50.7l1.8-1.7L69.3,60.8z"/></svg></button>',
    //nextArrow: $('.gb-main-product-arrows .carousel-next'),
    //prevArrow:  $('.gb-main-product-arrows .carousel-prev'),
    //responsive: [
    //{
    //  breakpoint: 767,
    //  settings: {
    //  slidesToShow:2,
    //  }
    // }
    //]
  });
  //$('.gb-main-product-arrows .carousel-prev').click(function(){
  //	$(this).parent().parent().find('.carousel-gb').slick('slickPrev');
  //});

  //$('.gb-main-product-arrows .carousel-next').click(function(e){
  //e.preventDefault();
  //$(this).parent().parent().find('.carousel-gb').slick('slickNext');
  //});

  $(".rq-thumbnail-slider").slick({
    slidesToShow: 6,
    slidesToScroll: 6,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
    infinite: false,

    prevArrow:
      '<button class="rq-PrevArrow-thumb" type="button" aria-label="Go to previous slide"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="75" height="75" viewBox="0 0 75 75" xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="23.8" y="23.2" class="st0" width="26.6" height="27.8"/><path d="M58.4,37.6c0-11.8-9.6-21.4-21.4-21.4s-21.4,9.6-21.4,21.4S25.2,59,37,59S58.4,49.4,58.4,37.6L58.4,37.6z M32.7,37.6l7.1-7	l1.1,1.1l-6,6l6,6.2l-1.1,1L32.7,37.6z"/></svg></button>',
    nextArrow:
      '<button class="rq-NextArrow-thumb" type="button" aria-label="Go to next slide"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="75" height="75" viewBox="0 0 75 75"><style type="text/css">	.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="24.8" y="23.1" class="st0" width="27" height="28.9"/><path d="M16.6,37.4c0,11.8,9.6,21.4,21.4,21.4s21.4-9.6,21.4-21.4S49.8,16,38,16S16.6,25.6,16.6,37.4z M42.3,37.4l-7.1,7l-1.1-1.1	l6-6l-6-6.2l1.1-1L42.3,37.4z"/></svg></button>',
  });

  $(".rq-thumbnail-slider a.thumb.slick-slide").click(function (e) {
    e.preventDefault();
    var slideno = $(this).attr("data-slick-index");
    $(".rq-product-slider-new").slick("slickGoTo", slideno);
  });

  /*$(".rq-product-slider-new-popup").slick({
    slidesToShow:1,
    slidesToScroll:1,
    dots:false,
    draggable:true, 
    adaptiveHeight: true,
    infinite:false,
    prevArrow:'<button class="rq-PrevArrow"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  x="0px" y="0px"	 width="123" height="122" viewBox="0 0 123 122" xml:space="preserve"><style type="text/css">.st3{fill:#000000;stroke:#FFFFFF;stroke-miterlimit:10;}</style><rect x="40.4" y="41.4" class="st3" width="43.2" height="40.3"/><path d="M95.8,61.2c0-19.2-15.7-34.8-35.1-34.8c-19.4,0-35.1,15.6-35.1,34.8c0,19.2,15.7,34.8,35.1,34.8	C80.1,95.9,95.8,80.4,95.8,61.2z M53.7,61.2l11.6-11.4l1.7,1.7l-9.8,9.7L67,71.3L65.2,73L53.7,61.2z"/></svg></button>',
    nextArrow:'<button class="rq-NextArrow"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="123" height="122" viewBox="0 0 123 122"  xml:space="preserve"><style type="text/css">.st3{fill:#000000;stroke:#FFFFFF;stroke-miterlimit:10;}</style><rect x="39.4" y="40.8" class="st3" width="43.2" height="40.3"/><path d="M27.2,60.8c0,19.2,15.7,34.8,35.1,34.8c19.4,0,35.1-15.6,35.1-34.8c0-19.2-15.7-34.8-35.1-34.8 C42.9,26.1,27.2,41.6,27.2,60.8z M69.3,60.8L57.8,72.3L56,70.5l9.8-9.7L56,50.7l1.8-1.7L69.3,60.8z"/></svg></button>', 
  }); 
  $(".rq-product-slider-new .rq-go-to-slide").click(function(){  
    $(".rq-image-zoom-popup-main").addClass("show"); 
    $("body").addClass("s-drawer-open js-drawer-open-right"); 
    $("html").addClass("no-scroll"); 
    var slideno2 = $(this).attr('data-slick-index');
    $('.rq-product-slider-new-popup').slick('slickGoTo', slideno2); 
   });
   $(".rq-close-popup").click(function(){
    $(".rq-image-zoom-popup-main").removeClass("show"); 
    $("html").removeClass("no-scroll");  
    $("body").removeClass("s-drawer-open js-drawer-open-right");  
   });
   $(".rq-overlay-popup").click(function(){ 
    $(".rq-image-zoom-popup-main").removeClass("show"); 
    $("html").removeClass("no-scroll");  
    $("body").removeClass("s-drawer-open js-drawer-open-right");  
   });*/

  $("[data-fancybox]").Fancybox({
    autoFocus: false,
    backFocus: false,
  });
});

// PDP accordion rq--features-dropdown-with-image-or-video.liquid// CSS animation maps:
const rotateH = {
  transform: "rotateZ(90deg)",
  left: 0,
};

const rotateH_Rev = {
  transform: "rotateZ(0deg)",
  top: "50%",
};

const rotateV = {
  transform: "rotateZ(90deg)",
  top: 0,
};

// Wait for DOM content to be loaded:
$(function () {
  /*RQ! 'Roll-down sections cause wild jumps' for commented STARTS*/
  /*$('li').on('click', '.rq--accordion-inactive', evt => {
    const $currTarg = $(evt.currentTarget),
    $accordion = $currTarg.next('.rq--accordion-content'),
    $lineH = $currTarg.find('.rq--accordion-line-h');
    $('h2.rq--accordion-active').trigger('click');
    $lineH.css(rotateH);
    setTimeout(() => {
      $lineH.parent().css({ transform: 'rotateZ(90deg)' });
      $currTarg.toggleClass('rq--accordion-inactive rq--accordion-active');
    }, 250);
  });

  $('li').on('click', '.rq--accordion-active', evt => {
    const $currTarg = $(evt.currentTarget),
    $accordion = $currTarg.next('.rq--accordion-content'),
    $lineH = $currTarg.find('.rq--accordion-line-h');
    $currTarg.find('.rq--accordion-sign').css({ transform: 'rotateZ(90deg)' });
    setTimeout(() => {
      $lineH.css(rotateH_Rev);
      $currTarg.toggleClass('rq--accordion-inactive rq--accordion-active');
    }, 250);
  });*/

  /* $('li').on('click', '.rq--accordion1-inactive', evt => {
    const $currTarg = $(evt.currentTarget),
    $accordion = $currTarg.next('.rq--accordion1-content'),
    $lineH = $currTarg.find('.rq--accordion-line-h');
    $('h2.rq--accordion1-active').trigger('click');
    $lineH.css(rotateH);
    setTimeout(() => {
      $lineH.parent().css({ transform: 'rotateZ(90deg)' });
      $currTarg.toggleClass('rq--accordion1-inactive rq--accordion1-active');
    }, 250);
  });

  $('li').on('click', '.rq--accordion1-active', evt => {
    const $currTarg = $(evt.currentTarget),
    $accordion = $currTarg.next('.rq--accordion1-content'),
    $lineH = $currTarg.find('.rq--accordion-line-h');
    $currTarg.find('.rq--accordion-sign').css({ transform: 'rotateZ(90deg)' });
    setTimeout(() => {
      $lineH.css(rotateH_Rev);
      $currTarg.toggleClass('rq--accordion1-inactive rq--accordion1-active');
    }, 250);
  });*/
  /*RQ! 'Roll-down sections cause wild jumps' for commented ENDS*/

  /****** ACCORDION COMPLETELY REFACTORED 10/18/2024 FOR ADA COMPLIANCE.
   * I DONT THINK ANY OF THIS IS CURRENTLY IN USE.
   * I'M LEAVING THIS UNCOMMENTED OUT BECAUSE THIS CODEBASE IS ABYSMAL
   * AND THESE EVENTS COULD BE IN USE IN AN UNRELATED COMPONENT.
   * REFER TO ACCORDION.JS IN THE ASSETS FOLDER FOR THE CURRENT IMPLEMENTATION
   *******/

  /*RQ! 'Roll-down sections cause wild jumps' STARTS*/
  $("button").on("click", ".rq--accordion-active", (evt) => {
    const $currTarg = $(evt.currentTarget),
      $accordion = $currTarg.next(".rq--accordion-content"),
      $lineH = $currTarg.find(".rq--accordion-line-h");
    //$currTarg.find('.rq--accordion-sign').css({ transform: 'rotateZ(90deg)' });
    //$lineH.css(rotateH);
    setTimeout(() => {
      //$lineH.css(rotateH_Rev);
      $lineH.removeAttr("style");
      $lineH.removeClass("rq-rotate");
      $currTarg.toggleClass("rq--accordion-inactive rq--accordion-active");
    }, 250);
  });
  $("button").on("click", ".rq--accordion-inactive", (evt) => {
    const $currTarg = $(evt.currentTarget),
      $accordion = $currTarg.next(".rq--accordion-content"),
      $lineH = $currTarg.find(".rq--accordion-line-h");
    //$lineH.css(rotateH);
    //$lineH.remove('rq-rotate');
    setTimeout(() => {
      //$lineH.parent().css({ transform: 'rotateZ(90deg)' });
      $lineH.addClass("rq-rotate");
      $currTarg.toggleClass("rq--accordion-inactive rq--accordion-active");
    }, 250);
  });

  $("button").on("click", ".rq--accordion1-active", (evt) => {
    const $currTarg = $(evt.currentTarget),
      $accordion = $currTarg.next(".rq--accordion1-content"),
      $lineH = $currTarg.find(".rq--accordion-line-h");
    //$currTarg.find('.rq--accordion-sign').css({ transform: 'rotateZ(90deg)' });
    //$lineH.css(rotateH);
    setTimeout(() => {
      //$lineH.css(rotateH_Rev);
      $lineH.removeAttr("style");
      $lineH.removeClass("rq-rotate");
      $currTarg.toggleClass("rq--accordion1-inactive rq--accordion1-active");
    }, 250);
  });
  $("button").on("click", ".rq--accordion1-inactive", (evt) => {
    const $currTarg = $(evt.currentTarget),
      $accordion = $currTarg.next(".rq--accordion1-content"),
      $lineH = $currTarg.find(".rq--accordion-line-h");
    //$lineH.css(rotateH);
    //$lineH.remove('rq-rotate');
    setTimeout(() => {
      //$lineH.parent().css({ transform: 'rotateZ(90deg)' });
      $lineH.addClass("rq-rotate");
      $currTarg.toggleClass("rq--accordion1-inactive rq--accordion1-active");
    }, 250);
  });
  /*RQ! 'Roll-down sections cause wild jumps' ENDS*/
  $(".default").trigger("click");
});
/******************************************************************************************/

// TTP - Gallery issue with variants STARTS
$(document).ready(function () {
  var rq_def_var_img = $("option:selected", ".rq-get-img-scr").attr("data-slick-slider-change");
  var go_to_def = $(".rq-product-slider-new")
    .find('.rq-go-to-slide[data-slick-slider-change*="' + rq_def_var_img + '"]')
    .attr("data-slick-index");
  $(".rq-product-slider-new").slick("slickGoTo", go_to_def);

  $(".rq-get-img-scr").change(function () {
    var rq_get_img = $("option:selected", this).attr("data-slick-slider-change");
    var go_to = $(".rq-product-slider-new")
      .find('.rq-go-to-slide[data-slick-slider-change*="' + rq_get_img + '"]')
      .attr("data-slick-index");
    $(".rq-product-slider-new").slick("slickGoTo", go_to);
  });
});

// TTP - Gallery issue with variants ENDS

// UL function to open + sign

// RQ's code for 'Quickview gallery slider' STARTS
/*$(document).ready(function(){
  
 $("a.quick-add-button-variants.button.button-primary").click(function(){ 
   $('.rq-product-slider-new').hide();
    setTimeout(function () {
       $(".rq-product-slider-new").slick({
          slidesToShow:1,
          slidesToScroll:1,
          dots:false,
          draggable:true, 
          adaptiveHeight: true,
          infinite:false,
          prevArrow:'<button class="rq-PrevArrow"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  x="0px" y="0px"	 width="123" height="122" viewBox="0 0 123 122" xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="40.4" y="41.4" class="st0" width="43.2" height="40.3"/><path d="M95.8,61.2c0-19.2-15.7-34.8-35.1-34.8c-19.4,0-35.1,15.6-35.1,34.8c0,19.2,15.7,34.8,35.1,34.8	C80.1,95.9,95.8,80.4,95.8,61.2z M53.7,61.2l11.6-11.4l1.7,1.7l-9.8,9.7L67,71.3L65.2,73L53.7,61.2z"/></svg></button>',
          nextArrow:'<button class="rq-NextArrow"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"	 width="123" height="122" viewBox="0 0 123 122"  xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="39.4" y="40.8" class="st0" width="43.2" height="40.3"/><path d="M27.2,60.8c0,19.2,15.7,34.8,35.1,34.8c19.4,0,35.1-15.6,35.1-34.8c0-19.2-15.7-34.8-35.1-34.8 C42.9,26.1,27.2,41.6,27.2,60.8z M69.3,60.8L57.8,72.3L56,70.5l9.8-9.7L56,50.7l1.8-1.7L69.3,60.8z"/></svg></button>', 
       });

       $('.rq-thumbnail-slider').slick({
          slidesToShow: 6,
          slidesToScroll: 6,
          dots: false,
          arrows: true, 
          adaptiveHeight: true, 
          infinite:false, 

          prevArrow: '<button class="rq-PrevArrow-thumb"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="75" height="75" viewBox="0 0 75 75" xml:space="preserve"><style type="text/css">.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="23.8" y="23.2" class="st0" width="26.6" height="27.8"/><path d="M58.4,37.6c0-11.8-9.6-21.4-21.4-21.4s-21.4,9.6-21.4,21.4S25.2,59,37,59S58.4,49.4,58.4,37.6L58.4,37.6z M32.7,37.6l7.1-7	l1.1,1.1l-6,6l6,6.2l-1.1,1L32.7,37.6z"/></svg></button>',
          nextArrow: '<button class="rq-NextArrow-thumb"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="75" height="75" viewBox="0 0 75 75"><style type="text/css">	.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}</style><rect x="24.8" y="23.1" class="st0" width="27" height="28.9"/><path d="M16.6,37.4c0,11.8,9.6,21.4,21.4,21.4s21.4-9.6,21.4-21.4S49.8,16,38,16S16.6,25.6,16.6,37.4z M42.3,37.4l-7.1,7l-1.1-1.1	l6-6l-6-6.2l1.1-1L42.3,37.4z"/></svg></button>',
        });


        $('.rq-thumbnail-slider a.thumb.slick-slide').click(function(e) {
         e.preventDefault();
          var slideno = $(this).attr('data-slick-index');
          $('.rq-product-slider-new').slick('slickGoTo', slideno);
        });
       $('.rq-product-slider-new').show();
   }, 1800);  
 });
}); */
// RQ's code for 'Quickview gallery slider' ENDS

// RQ's code for HTML metafiled STARTS
var stringToHTML = function (str) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(str, "text/html");
  return doc.body;
};

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[0]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[0].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[1]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[1].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[2]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[2].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[3]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[3].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[4]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[4].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[5]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[5].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[6]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[6].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[7]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[7].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[8]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[8].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[9]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[9].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[10]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[10].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[11]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[11].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[12]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[12].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[13]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[13].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[14]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[14].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[15]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[15].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[16]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[16].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[17]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[17].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[18]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[18].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[19]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[19].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[20]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[20].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[21]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[21].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[22]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[22].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[23]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[23].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[24]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[24].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[25]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[25].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[26]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[26].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[27]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[27].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[28]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[28].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[29]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[29].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];

var meta_specification = document.getElementsByClassName("metafield-multi_line_text_field")[30]
  .innerText;
document.getElementsByClassName("metafield-multi_line_text_field")[30].innerHTML =
  stringToHTML(meta_specification)["innerHTML"];
// RQ's code for HTML metafiled ENDS


document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('#AddToCartForm');
  var trigger = document.querySelector('#BIS_trigger');
  var productJsonEl = document.querySelector('.product-json');
  if (!form || !trigger || !productJsonEl) return;
  var product = JSON.parse(productJsonEl.textContent);
  form.addEventListener('change', function () {
    var variantIdInput = form.querySelector('[name="id"]');
    if (!variantIdInput) return;
    var variant = product.variants.find(function (v) {
      return String(v.id) === String(variantIdInput.value);
    });
    if (!variant) return;
    trigger.setAttribute('data-variant-id', variant.id);
    trigger.style.display = variant.available ? 'none' : '';
  });
});